import { Text } from 'library';
import moment from 'moment';
import { Employment } from 'parent-portal/provider-profile/providerProfileModels';
import React, { useEffect, useState } from 'react';
import { formatMonthYear } from 'shared/Dates';
import Highlight from './Highlight';

export default function ExperienceHighlight({ employment }: { employment: Employment[] }) {
    const [latestEmployment, setLatestEmployment] = useState<Employment>();

    useEffect(() => {
        employment.sort((a, b) => moment(b.start_date).unix() - moment(a.start_date).unix());
        setLatestEmployment(employment[0]);
    }, [employment]);

    return (
        <Highlight title="Recent Employment">
            {latestEmployment && (
                <div style={{ marginTop: 8, marginBottom: 8 }}>
                    <Text>
                        <b>{latestEmployment.role}</b>{' '}
                        {latestEmployment.start_date ? formatMonthYear(latestEmployment.start_date) : ''}
                        {latestEmployment.end_date ? ` - ${formatMonthYear(latestEmployment.end_date)}` : ''}
                    </Text>
                    <Text variant="body2">{latestEmployment.employer_name}</Text>
                    <Text variant="body2">{latestEmployment.description}</Text>
                </div>
            )}
        </Highlight>
    );
}
